import { Logout, SettingsBackupRestore } from "@mui/icons-material";
import { ListItemIcon, Menu, MenuItem, Divider } from "@mui/material";
import { FC, MouseEventHandler } from "react";

type Props = {
  onLogout?: MouseEventHandler;
  onRevert?: MouseEventHandler;
  onClose?: () => void;
  anchorEl: Element | null;
  open: boolean;
};

const UserMenu: FC<Props> = ({ onLogout, onRevert, onClose, anchorEl, open }) => {
  const isImpersonated = localStorage.getItem("Abp.ImperonatingToken") !== null;

  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={onClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {isImpersonated && (
          <MenuItem onClick={onRevert}>
            <ListItemIcon>
              <SettingsBackupRestore fontSize="small" />
            </ListItemIcon>
            Back to myself
          </MenuItem>
        )}
        {isImpersonated && <Divider />}

        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
};

export default UserMenu;
